module.exports = __webpack_public_path__ + "static/design-ops-1f9f7fd052539a598f0e7c214fa7fa33.png";